import React, { useEffect, useState, useRef } from 'react';
import { Checkbox, Divider } from '@drip/drip-design';
import IconTip from '@/components/icon-tip';
import { INDICATORS_DATA } from '../../config';
import { Down16, Up16 } from '@drip/drip-design-icons';
import classnames from 'classnames';
const lastTarget = ['search_uv', 'search_item_piece', 'search_ord_deal_ord_amt', 'fo_uctr'];
interface IProps {
  name: string;
  value: string;
  tip: string;
}
function AnalysisFilter(props: any) {
  const { onChange, tabsIdx } = props;
  const _onChange = useRef(onChange);
  const [indicators, setIndicators] = useState<any[] | []>(lastTarget);
  const isIndicatorsChange = useRef(false);
  /**
   * 获取指标个数
   * @param arr
   * @returns
   */
  const getItemLength = (arr: Array<any>) => {
    let length = 0;
    arr.map((item) => {
      length = length + item.items.length;
    });
    return length;
  };
  /**
   * 获取选中指标key
   * @param arr
   * @returns
   */
  const getAllItemsKey = (arr: Array<any>) => {
    let keys: Array<string> = [];
    arr.map((item) => {
      item.items.map((ele: any) => {
        keys.push(ele.value);
      });
    });
    return keys;
  };
  /**
   * 指标选项勾选
   * @param checkedValues
   */
  const onChangeIndicators = (checkedValues: any, isChange = true) => {
    isIndicatorsChange.current = isChange;
    setIndicators([...checkedValues]);
  };
  /**
   * 监听指标变化
   */
  useEffect(() => {
    console.log(isIndicatorsChange.current, 'isIndicatorsChange.current');
    if (!_onChange.current || !isIndicatorsChange.current) return;
    _onChange.current({ indicators: indicators });
  }, [indicators]);

  useEffect(() => {
    onChangeIndicators(lastTarget, false);
  }, [tabsIdx]);

  return (
    <div className="analysis-filter">
      {/* 筛选数据指标 */}
      <div className="analysis-filter-title-control">
        <div className="analysis-filter-title">
          <strong>数据指标展示设置</strong> (已选 {indicators.length}/{getItemLength(INDICATORS_DATA)})
        </div>
        <div className="analysis-filter-control">
          <a onClick={() => onChangeIndicators(getAllItemsKey(INDICATORS_DATA))}>全选</a>
          <Divider type="vertical" />
          <a onClick={() => onChangeIndicators(lastTarget)}>重置</a>
          <Divider type="vertical" />
          <a onClick={() => onChangeIndicators([])}>清空</a>
        </div>
      </div>
      {/* 指标列表 */}
      <Checkbox.Group onChange={onChangeIndicators} value={indicators} style={{ width: '100%' }}>
        {INDICATORS_DATA.map((data, idx) => {
          return <RenderIndicators data={data} key={idx} />;
        })}
      </Checkbox.Group>
    </div>
  );
}
// 渲染指标列表
function RenderIndicators(props: { data: { name: string; items: Array<IProps> } }) {
  const { data } = props;
  const [isExpand, setIsExpand] = useState(false);
  return (
    <div className={classnames('analysis-filter-list', { 'analysis-filter-list-extend': isExpand })}>
      <div className="analysis-filter-list-title">{data.name}</div>
      <ul className="analysis-filter-list-ul">
        {data.items.map((item: IProps) => {
          return (
            <li className="analysis-filter-list-item" key={item.value}>
              <Checkbox value={item.value}>
                {item.name}
                <IconTip title={item.tip} size="small" />
              </Checkbox>
            </li>
          );
        })}
      </ul>
      {data.items.length > 6 && (
        <a onClick={() => setIsExpand(!isExpand)} className="analysis-filter-list-expand">
          {!isExpand ? (
            <>
              更多
              <Down16 />
            </>
          ) : (
            <>
              收起
              <Up16 />
            </>
          )}
        </a>
      )}
    </div>
  );
}
export default AnalysisFilter;
